export default "__VITE_ASSET__ClS8RY6T__"